import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CheckboxCustomEvent, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { TerminosPage } from '../../../private/terminos/terminos.page';
import { agreeLegals } from '../../../store/actions/legals.actions';
import { AppState } from '../../../store/app-reducers';
import { LegalAgreeState } from '../../../store/reducers/legals.reducer';
import { GTMEventsCrash } from '../../enums/Crashlytics';
import { EventInteraction, GTMInteractions } from '../../models/Constants';
import { ILegacyVersions } from '../../models/Legales';
import { AnalyticsService } from '../../services/analytics.service';
import { CrashlyticsService } from '../../services/crashlytics/crashlytics.service';
import { SharedServiceService } from '../../services/shared-service.service';
import { ToastControllerService } from '../../services/toast-controller.service';

@Component({
  selector: 'app-legal-change',
  templateUrl: './legal-change.page.html',
  styleUrls: ['./legal-change.page.scss'],
})
export class LegalChangePage implements OnInit, OnDestroy {

  @Input() legales: ILegacyVersions[] = [];

  public responsable: Observable<string>;
  public legalesForm: UntypedFormGroup = {} as UntypedFormGroup;
  public loading = false;

  private errorUpdateLegal = '';
  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private sharedS: SharedServiceService
    , private analytS: AnalyticsService
    , private toastS: ToastControllerService
    , private translate: TranslateService
    , private modalCtrl: ModalController
    , private store: Store<AppState>
    , private fb: UntypedFormBuilder
    , private crashlytics: CrashlyticsService
  ) {
    this.responsable = this.store.select('userData').pipe(map(value => value.Responsable));
  }

  async ngOnInit() {
    this.legalesForm = this.fb.group({
      1: [false, [Validators.requiredTrue]],
      2: [false, [Validators.requiredTrue]],
    });

    this.store.select('AgreeLegals')
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(this.callbackAcceptLegals);

    this.errorUpdateLegal = this.translate.instant('CatCodes.error_update_legal');
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  /**
   * * Callback de los cambios de legales
   */
  private callbackAcceptLegals = async (resp: LegalAgreeState) => {
    this.loading = resp.loading;
    if (resp.success) {
      await this.toastS.presentToast(resp.data, null, 'alert', 4000, 'toast-network')
      await this.modalCtrl.dismiss(true)
    }

    if (resp.error) {
      await this.toastS.presentToast(this.errorUpdateLegal, null, 'alert', 4000, 'toast-network')
      await this.crashlytics.sendCrashPlatform(GTMEventsCrash.legalModalApi, resp.error)
    }
  }

  public changeStatusCheck = (event: CheckboxCustomEvent, id: number) => {
    const value = event.detail.checked;
    if (id === 1 && value) {
      this.analytS.sendEventAnalytics(GTMInteractions.acceptNewTermsEvent, EventInteraction)
    }
    if (id === 2 && value) {
      this.analytS.sendEventAnalytics(GTMInteractions.acceptNewNoticeEvent, EventInteraction)
    }
  }

  public onLegals = async (legal: ILegacyVersions) => {
    await this.sharedS.loadingBottle()
    const accept = await this.sharedS.modalLegales(TerminosPage, legal.tipo, legal.boton)
    // TODO JAIR: VALIDAR INTERACCION
    this.analytS.fbAnalytics('interacciones', { data_categoria: 'aviso_de_privacidad', data_accion: '/Mas', data_etiqueta: accept ? 'aceptar' : 'atras' })
    this.legalesForm.get(legal.ID_LegalTipo.toString())?.setValue(accept);
  }

  public formSubmit = () => {
    if (this.legalesForm.invalid) { return; }
    this.store.dispatch(agreeLegals());
    this.analytS.sendEventAnalytics(GTMInteractions.acceptNewTermsAndNoticeEvent, EventInteraction);
  }

}
